





























































































import ProviderMarkup from "@/store/entities/flight/providerMarkup";


import { Component, Vue } from "vue-property-decorator";
import AddProviderMarkupModal from "./modals/addProviderMarkupModal.vue";

@Component({
  components: { AddProviderMarkupModal },
})
export default class WebServiceMarkupPage extends Vue {
  isOpenModal: boolean = false;
  mockData: any[] = [];
  headers: any[] = [];
  breadcrumbsItems: any[] = [];
  providerMarkups: ProviderMarkup[] = [];
  providerMarkup:ProviderMarkup=new ProviderMarkup();

  get groupedProviderMarkups() {
    return [...this.providerMarkups]
      .sort((a, b) => {
        // Önce metaSearchAgency.referrerId'ye göre sırala
        const aReferrerId = a.metaSearchAgency && a.metaSearchAgency.referrerId || '';
        const bReferrerId = b.metaSearchAgency && b.metaSearchAgency.referrerId || '';
        const referrerCompare = aReferrerId.localeCompare(bReferrerId);
        if (referrerCompare !== 0) return referrerCompare;

        // Sonra company name'e göre sırala
        const aCompanyName = a.company && a.company.name || '';
        const bCompanyName = b.company && b.company.name || '';
        const companyCompare = aCompanyName.localeCompare(bCompanyName);
        if (companyCompare !== 0) return companyCompare;

        // Sonra fromAirportId'ye göre sırala
        const fromCompare = (a.fromAirportId || '').localeCompare(b.fromAirportId || '');
        if (fromCompare !== 0) return fromCompare;

        // Son olarak toAirportId'ye göre sırala
        return (a.toAirportId || '').localeCompare(b.toAirportId || '');
      })
      .map(item => ({
        ...item,
        metaSearchAgency: {
          ...item.metaSearchAgency,
          referrerId: (item.metaSearchAgency && item.metaSearchAgency.referrerId || '').trim().toUpperCase()
        }
      }));
    }
  async getProviderMarkups() {
    await this.$store.dispatch({
      type: "providerMarkup/getProviderMarkups"
    });
    
   this.providerMarkups = this.$store.state.providerMarkup.list;
  
  }

  async created() {
    await this.getProviderMarkups();
    
    (this.headers = [
      { text: "Servis", value: "service" },
      { text: "Provider", value: "provider" },
      { text: "Havalimanı", value: "airports" },
      { text: "Yüzde", value: "percentage" },
      { text: "Fiyat", value: "price" },
      { text: "Para Birimi", value: "currency" },
      { text: "İşlemler", value: "transactions" },
    ]),


    this.breadcrumbsItems = [
      { text: "Ana Sayfa", disabled: false, href: "/#/main/home" },
      { text: "Uçuş", disabled: true },
      { text: "Provider Markup", disabled: true },
    ];
  }



  openModal() {
    
    this.isOpenModal = true;
  }
  closeModal() {
    this.isOpenModal = false;
    this.$store.state.webServiceMarkup.editAuxiliaryMarkup=null;
    this.getProviderMarkups()
  }

  editAuxiliaryMarkup(item) {
    
    this.$store.state.webServiceMarkup.editAuxiliaryMarkup = item;
    this.isOpenModal = true;
  }

  async deleteProviderServiceMarkup(item) {
    await this.$store
      .dispatch({
        type: "providerMarkup/deleteProviderMarkup",
        payload: item.id,
      })
      .then((x) => {
       this.getProviderMarkups()
      });
  }

    confirmDelete(item) {
    this.$swal({
      title: "Satır Silinecetir.",
      text: "İşlemi Devam Ettirmeye Emin misiniz?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Evet",
      cancelButtonText: "Hayır",
    }).then((result) => {
      if (result.isConfirmed) {
        this.deleteProviderServiceMarkup(item);
        Vue.$toast.success("Silme Başarılı");
      }
    });
  }


}
